import { render, staticRenderFns } from "./AssetPropertyForm.vue?vue&type=template&id=6a3703a9&scoped=true&"
import script from "./AssetPropertyForm.vue?vue&type=script&lang=ts&"
export * from "./AssetPropertyForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssetPropertyForm.vue?vue&type=style&index=0&id=6a3703a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3703a9",
  null
  
)

export default component.exports